import React from 'react';
import { connect } from "react-redux";
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import updatePosProstor from './../../../API/Admin/PutBusinessPremises'
import Loader from './../../../Global/loader'

class UpdatePosProstor extends React.Component {
    constructor(props) {
        super(props); 
        this.submitUpdate = this.submitUpdate.bind(this);
    }

    state={
        loading: false,
        ecommerce: this.props.onePosPro.ecommerce
    }

    
    handleUpdateChange = async (e) => {
        await this.props.mapState("ADMIN_CHANGE_ONE_POSLOVNI_PROSTOR_DETAILS", e.target) 
    }

    submitUpdate = async (e) =>{
        e.preventDefault()
        const onePosPro = { ...this.props.onePosPro };
        onePosPro.ecommerce = this.state.ecommerce;
        let updatePP = await updatePosProstor(this.props.oneClientInfo.uuid, onePosPro)
        if(updatePP.data.data.operationResult === "SUCCESS"){
            store.addNotification({
                title: "Uspješno!",
                message: "Promjena poslovnog prostora je izvršena",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  pauseOnHover: true
                }
            });
        }
        else(
            store.addNotification({
                title: "Greška!",
                message: "Došlo je do pogreške prilikom promjene Poslovnog Prostora, molimo pokušajte ponovno.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })
        )
        this.props.goBack()
    }

    handleEcommerce = async () => {
        this.setState({
            ecommerce: !this.state.ecommerce
        })
    } 

    render(){  
        return (
            <>
                {this.state.loading ?
                    <div style={{position: "sticky", marginTop: "50px", left: "50%"}}>
                        <Loader />
                    </div>
                :
                <form style={{padding: "40px"}}>
                    <div className="row">          
                        <div className="col col-sm-12 col-lg-6 col-md-12">
                            <div className="form-group row">
                                <label htmlFor="label" className="col-sm-4 col-form-label">Oznaka</label>
                                <div className="col-sm-8">
                                    <input      
                                        id="label"                          
                                        type="text"
                                        value={this.props.onePosPro.label}
                                        onChange={e => this.handleUpdateChange(e)}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="address" className="col-sm-4 col-form-label">Adresa</label>
                                <div className="col-sm-8">
                                    <input
                                        id="address"  
                                        type="text"
                                        value={this.props.onePosPro.address}
                                        onChange={e => this.handleUpdateChange(e)}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="description" className="col-sm-4 col-form-label">Opis</label>
                                <div className="col-sm-8">
                                    <input  
                                        id="description"                         
                                        type="text"
                                        value={this.props.onePosPro.description}
                                        onChange={e => this.handleUpdateChange(e)}
                                    />
                                </div>
                            </div>  

                            <div className="form-group row">
                                <label htmlFor="premises_name" className="col-sm-4 col-form-label">Naziv prostora</label>
                                <div className="col-sm-8">
                                    <input  
                                        id="premises_name"                         
                                        type="text"
                                        value={this.props.onePosPro.premises_name}
                                        onChange={e => this.handleUpdateChange(e)}
                                    />
                                </div>
                            </div>  

                            <div className="form-group row" style={{ alignItems: 'center' }}>
                                <label htmlFor="E-commerce" className="col-sm-4 col-form-label">E-commerce</label>
                                <div className="col-sm-8">
                                    <label className="form-check-label" htmlFor="ecommerce">
                                        <input      
                                            id="ecommerce"                                          
                                            type="checkbox"
                                            checked={this.state.ecommerce}
                                            onChange={e => this.handleEcommerce(e)}
                                        />
                                        &nbsp;&nbsp; e-commerce
                                    </label>
                                </div>
                            </div>

                            <div className="col-sm-4" style={{float:"right",padding: "0px"}}>
                                <button
                                    className="btn btn-info" 
                                    style={{padding:"10px"}} 
                                    onClick={(e) => this.submitUpdate(e)}
                                >
                                    Spremi
                                </button>
                            </div>                                  
                        </div>                        
        
                        
                    </div>           
                    
                    <div
                        className="btn btn-default" 
                        style={{/*width: "100%",*/ marginBottom: "10px", marginTop: "10px"}}
                        onClick={(e) => this.props.goBack(e)}
                    >
                        <BsBackspaceFill size={30} />  <strong>Nazad</strong>
                    
                    </div>    
                
                </form>
                }     
            </>

        )
    }
}
const mapStateToProps = state => {
    return {
        oneClientInfo: state.adminClient.oneClient,
        posProstorList: state.adminClient.posProstorList,
        onePosPro: state.adminClient.onePosPro
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(UpdatePosProstor);


